import React from "react";
import { string, oneOfType, objectOf, number } from "prop-types";

const Tip = ({ style, className }) => (
	<i
		style={{
			...style,
			display: "inline-block",
			fill: "currentColor",
		}}
		className={className}>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="42.964"
			height="40.674"
			viewBox="0 0 42.964 40.674">
			<g transform="translate(-692.665 -1401.451)">
				<rect
					width="9.817"
					height="1.988"
					rx="0.994"
					transform="translate(709.219 1436.649)"
					fill="none"
					style={{ stroke: "currentcolor" }}
					strokeMiterlimit="10"
					strokeWidth="1"
				/>
				<rect
					width="9.817"
					height="2.988"
					rx="1.494"
					transform="translate(709.219 1438.637)"
					fill="none"
					style={{ stroke: "currentcolor" }}
					strokeMiterlimit="10"
					strokeWidth="1"
				/>
				<g transform="translate(164.112 1211.459)">
					<path
						d="M553.082,232.022c-.691-.619-.8-5.273-5.993-9.362-2.619-2.062-3.707-4.949-3.064-9.082s4.745-5.561,8.007-4.234,4.745,3.877,4.6,6.071-1.582,1.428-1.582,0,.692-4.694,3.164-5.97a7.215,7.215,0,0,1,7.958.765c2.224,1.939,3.145,10.093-.612,11.57-7.293,4.573-5.087,8.814-6.6,10.021C558.494,232.177,553.082,232.022,553.082,232.022Z"
						transform="translate(-5.649 -6.799)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M559.972,240.3a62.773,62.773,0,0,0-.018-6.644,10.194,10.194,0,0,0-.7-2.266"
						transform="translate(-11.471 -15.407)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M562.661,241.261c-.073-.951.686-4.321-.165-5.943-.43-.82.9-.591,1-2.315"
						transform="matrix(0.995, 0.105, -0.105, 0.995, 15.99, -73.727)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M557.006,230.1c0-.8,1.139-2.623,2.319-2.623s1.538,2.19,1.538,2.99a1.8,1.8,0,0,1-1.721,1.879A2.537,2.537,0,0,1,557.006,230.1Z"
						transform="translate(-11.7 -15.504)"
						style={{ fill: "currentcolor" }}
					/>
					<path
						d="M565.906,231.138c0,.724-1.031,2.375-2.1,2.375s-1.393-1.984-1.393-2.708a1.625,1.625,0,0,1,1.557-1.7A2.3,2.3,0,0,1,565.906,231.138Z"
						transform="matrix(0.995, 0.105, -0.105, 0.995, 15.764, -73.838)"
						style={{ fill: "currentcolor" }}
					/>
					<path
						d="M565.724,230.922a1.8,1.8,0,0,1,1.063-.022.45.45,0,0,1,.268.571,2.977,2.977,0,0,1-.367.585.541.541,0,0,0-.066.614.447.447,0,0,0,.256.173"
						transform="matrix(0.899, 0.438, -0.438, 0.899, 146.818, -239.944)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M539.488,213.027a17.843,17.843,0,0,0-4.082-1.808"
						transform="translate(-2.462 -7.787)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M552.274,202.161c-.19-.291-.369-.588-.549-.886l-2.332-3.862"
						transform="translate(-7.745 -2.573)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M568.768,201.263a13.723,13.723,0,0,0,3.008-4.64"
						transform="translate(-15.063 -2.274)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M586.125,215.821q3.253-.029,6.5.012"
						transform="translate(-21.619 -9.521)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M541.648,203.781a84.8,84.8,0,0,0-7.922-6.627"
						transform="translate(-1.827 -2.475)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M561.759,198.74a17.624,17.624,0,0,0-.18-8.138"
						transform="translate(-12.348 0)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M581.041,204.122c.1-.372.465-.6.8-.792a23.405,23.405,0,0,0,4.644-3.6,14.684,14.684,0,0,1,1.77-1.639,5.569,5.569,0,0,1,.978-.558"
						transform="translate(-19.699 -2.619)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M536.049,222.329l-6.907,1.4"
						transform="translate(0 -11.984)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
					<path
						d="M586.646,224.059q2.326.468,4.607,1.133"
						transform="translate(-21.816 -12.637)"
						fill="none"
						style={{ stroke: "currentcolor" }}
						strokeLinecap="round"
						strokeMiterlimit="10"
						strokeWidth="1"
					/>
				</g>
			</g>
		</svg>
	</i>
);

Tip.propTypes = {
	className: string,
	style: objectOf(oneOfType([string, number])),
};
Tip.defaultProps = {
	className: "",
	style: {},
};

export default Tip;
export { Tip };
